import { Typography, TypographyProps } from "@mui/material";

interface TypographyPropsWithBold extends TypographyProps {
	bold?: boolean;
	htmlFor?: string;
}

export const BigText: React.FC<TypographyPropsWithBold> = ({ bold = false, children, sx, ...props }) => {
	return (
		<Typography sx={{ fontWeight: bold ? 600 : 400, ...sx }} variant="h4" {...props}>
			{children}
		</Typography>
	);
};

export const TitleText: React.FC<TypographyPropsWithBold> = ({ bold = false, children, sx, ...props }) => {
	return (
		<Typography sx={{ fontWeight: bold ? 600 : 400, ...sx }} variant="h6" {...props}>
			{children}
		</Typography>
	);
};

export const SubtitleText: React.FC<TypographyPropsWithBold> = ({ bold = false, children, sx, ...props }) => {
	return (
		<Typography sx={{ fontSize: "1rem", fontWeight: bold ? 600 : 500, ...sx }} variant="subtitle2" {...props}>
			{children}
		</Typography>
	);
};

export const BodyText: React.FC<TypographyPropsWithBold> = ({ bold = false, children, sx, ...props }) => {
	return (
		<Typography sx={{ fontWeight: bold ? 600 : 400, ...sx }} variant="body1" {...props}>
			{children}
		</Typography>
	);
};

export const BodyTextSmall: React.FC<TypographyPropsWithBold> = ({ bold = false, children, sx, ...props }) => {
	return (
		<Typography sx={{ fontWeight: bold ? 600 : 400, ...sx }} variant="body2" {...props}>
			{children}
		</Typography>
	);
};

export const BodyTextTiny: React.FC<TypographyPropsWithBold> = ({ bold = false, children, sx, ...props }) => {
	return (
		<Typography component="span" sx={{ fontSize: ".9em", fontWeight: bold ? 600 : 400, ...sx }} {...props}>
			{children}
		</Typography>
	);
};

export const CaptionText: React.FC<TypographyPropsWithBold> = ({ bold = false, children, sx, ...props }) => {
	return (
		<Typography sx={{ fontWeight: bold ? 600 : 400, ...sx }} variant="caption" {...props}>
			{children}
		</Typography>
	);
};

export const OverlineText: React.FC<TypographyPropsWithBold> = ({ bold = false, children, sx, ...props }) => {
	return (
		<Typography sx={{ fontWeight: bold ? 600 : 400, ...sx }} variant="overline" {...props}>
			{children}
		</Typography>
	);
};
